module.exports = __webpack_public_path__ + "img/code.aef76fbd.png";